module.exports = __webpack_public_path__ + "js/components/Explorer/images/winamp-mp3-8f994dbe6f0dcecde53550c590cb1f70.png";